import PricingPage from './PricingPage';

export const Pricing = () => <PricingPage />;
